import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './home';
import { LoginComponent } from './login';
import { AuthGuard } from './_helpers';
import { StudentComponent } from './student/student.component';
import { VerifierComponent } from './verifier/verifier.component';
import { VerifierSupervisorComponent } from './verifier-supervisor/verifier-supervisor.component';
import { AssociateComponent } from './associate/associate.component';
import { AssociateSupervisorComponent } from './associate-supervisor/associate-supervisor.component';
import { SuperAdminComponent } from './super-admin/super-admin.component';
import { UniversityComponent } from './university/university.component';
import { RegisterStudentComponent } from './pages/register-student/register-student.component';
import { RegisterEmployerComponent } from './pages/register-employer/register-employer.component';
import { EmployerComponent } from './employer/employer.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { VerificationFormComponent } from './verification-form/verification-form.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { EmailVerificationPageComponent } from './pages/email-verification-page/email-verification-page.component';
import{LoginnewComponent} from './loginnew/loginnew.component'
import { PaymentSuccessfulPageComponent } from './pages/payment-successful-page/payment-successful-page.component';
import { LandingPageComponent } from './landing-page/landing-page.component'
import {FaqComponent} from './faq/faq.component'
import { RefundPolicyComponent } from './refund-policy/refund-policy.component'

const routes: Routes = [
    { path: '', component: HomeComponent, canActivate: [AuthGuard] },
    { path: 'verification', component: LandingPageComponent },
    { path: 'login', component: LoginComponent },
    { path: 'student', component: StudentComponent },
    { path: 'verifier', component: VerifierComponent },
    { path: 'superVerifier', component: VerifierSupervisorComponent },
    { path: 'associate', component: AssociateComponent },
    { path: 'superAssociate', component: AssociateSupervisorComponent },
    { path: 'superAdmin', component: SuperAdminComponent },
    { path: 'university', component: UniversityComponent },
    { path: 'employer', component: EmployerComponent },
    { path: 'resetPassword', component: ResetPasswordComponent },
    { path: 'studentRegister', component: RegisterStudentComponent },
    { path: 'employerRegister', component: RegisterEmployerComponent },
    { path: 'verificationForm', component: VerificationFormComponent },
    { path: 'PageNotFound', component: PageNotFoundComponent },
    { path: 'emailVerification', component: EmailVerificationPageComponent },
    { path: 'loginNew', component: LoginnewComponent },
    { path: 'PaymentSuccessfulPage', component: PaymentSuccessfulPageComponent },
    { path: 'faq', component: FaqComponent },
    { path: 'refundPolicy', component: RefundPolicyComponent},
    // otherwise redirect to home
    { path: '**', redirectTo: 'PageNotFound' }
];

export const appRoutingModule = RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy',
scrollPositionRestoration: 'enabled' });